import characteristics from "../data/characteristics.json"

const qualityAdjustText = (qualities, mod) => {
    const match = /^(REM|SUB)QUAL(.+)$/.exec(mod.Key || "")
    if (!match) { return "" }
    const name = qualities.find((q) => q.Key === match[2])?.Name?.replace(/ Quality$/, "") || match[2]
    return match[1] === "REM" ? `Remove ${name} Quality` : `Decrease the ${name} Quality ${Math.abs(parseInt(mod.Count) || 1)}`
}

const qualityName = (quality, key) => (quality.ModDesc || quality.Name || key).replace(/ ?\{0\}/, "")

const coreModText = (qualities, talents, skills, mod, solo) => {
    let count = mod.Count || 1
    if (solo) { count = 1 }
    const quality = qualities.find((q) => q.Key === mod.Key)
    if (quality && mod.WeaponCountDamageMult) {
        const rating = `${qualityName(quality, mod.Key)} equal to ${mod.WeaponCountDamageMult}× damage (rounded ${mod.WeaponCountRound === "up" ? "up" : "down"})`
        return mod.QualReplace ? `Sets ${rating}` : mod.QualSet ? `Grants ${rating}` : `Increases ${rating}`
    }
    if (mod.Key === "RANGESUB" && mod.MinRange) {
        return `Decrease range by ${Math.abs(parseInt(mod.Count) || 1)} (minimum ${mod.MinRange})`
    }
    if (quality && mod.Count && (mod.QualSet || mod.QualReplace)) {
        const name = qualityName(quality, mod.Key)
        return (mod.QualSet ? `Grants ${name} ${mod.Count}` : `Sets ${name} to ${mod.Count}`) + (mod.ToIntegrated ? " (integrated weapon)" : "")
    }
    if (quality && mod.NewCount) {
        const name = qualityName(quality, mod.Key)
        return `Gains ${name} ${mod.NewCount}, or increases ${name} by ${mod.Count || 1}` + (mod.ToIntegrated ? " (integrated weapon)" : "")
    }
    let text =
        qualities.find((q) => q.Key === mod.Key)
            ? (!solo ? Math.abs(count) + " " : "") +
            qualities.find(
                (q) => q.Key === mod.Key,
            ).ModDesc +
            (count < 0 ? " -1" : "") +
            (count > 1 || count < -1
                ? " mods"
                : " mod")
            : talents.find((t) => t.Key === mod.Key)
                ? "Innate Talent: " +
                talents.find(
                    (t) => t.Key === mod.Key,
                ).Name
                : skills.find(
                    (s) => s.Key === mod.Key,
                )
                    ? count +
                    " Skill: " +
                    skills.find(
                        (s) => s.Key === mod.Key,
                    ).skill +
                    (count > 1 ? " mods" : " mod")
                    : characteristics.find((c) => c.Key === mod.Key) ?
                        (count ? count + " " : "1 ") + characteristics.find((c) => c.Key === mod.Key).Name + " mod" + (count > 1 ? "s" : "")
                        : qualityAdjustText(qualities, mod)
    if (text && mod.ToIntegrated) { text += " (integrated weapon)" }
    return text
}

const getModText = (qualities, talents, skills, mod, solo) => {
    let text = coreModText(qualities, talents, skills, mod, solo)
    if (text && mod.WeaponCountDamageMult && mod.ToIntegrated) { text += " (integrated weapon)" }
    if (text && mod.IfRangeBlocked) { text = "If range can't be reduced further: " + text }
    return text
}

export default getModText